// extracted by mini-css-extract-plugin
export default {"fab":"FAB_fab__5PEmF","list":"FAB_list__TFLfK","listItem":"FAB_listItem__mcorH","label":"FAB_label__uGU9T","button":"FAB_button__rxtt3"};